export default __webpack_public_path__ + "images/NO.34161a4.png";